module.exports = __webpack_public_path__ + "static/media/CourseTimeTrackedGrey.fcc3b214.svg";